module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-10000-with-gift-02d3a527.png";